export default "__VITE_ASSET__e3201714__"